// pages/Dashboard/DashboardContainer.jsx
import React, { useState } from "react";
import { BarChart3, Briefcase, ChevronRight } from "lucide-react";
import SalesDashboard from "./SalesDashboard";
import CasesDashboard from "./CasesDashboard";
import UpgradeDashboard from "./UpgradeDashboard";
import { useTheme } from "../../contexts/ThemeContext";

const DashboardContainer = () => {
  const [activeView, setActiveView] = useState("sales"); // 'sales' or 'cases'
  const { isDarkMode } = useTheme();

  const views = [
    {
      id: "sales",
      name: "Sales Performance",
      icon: BarChart3,
      description: "Sales metrics and team performance",
    },
    {
      id: "cases",
      name: "Case Management",
      icon: Briefcase,
      description: "Case tracking and support metrics",
    },
    {
      id: "upgrades",
      name: "Upgrade Management",
      icon: Briefcase,
      description: "Upgrade tracking and support metrics",
    },
  ];

  return (
    <div
      className={`min-h-screen font-inter transition-colors duration-300 ${isDarkMode ? "bg-[#0A0B0F]" : "bg-[#F4F5F7]"}`}
    >
      {/* Navigation Tabs */}
      <div
        className={`sticky top-0 z-10 border-b transition-colors ${isDarkMode ? "bg-[#0A0B0F] border-gray-800" : "bg-[#F4F5F7] border-gray-200"}`}
      >
        <div className="px-3 sm:px-8 py-3 sm:py-4">
          <div className="flex items-center gap-2 sm:gap-4">
            {views.map((view) => {
              const Icon = view.icon;
              const isActive = activeView === view.id;

              return (
                <button
                  key={view.id}
                  onClick={() => setActiveView(view.id)}
                  className={`flex items-center gap-2 sm:gap-3 px-3 sm:px-6 py-2 sm:py-3 rounded-lg transition-all ${
                    isActive
                      ? "bg-blue-600 text-white shadow-lg shadow-blue-600/20"
                      : isDarkMode
                        ? "bg-gray-900/50 text-gray-400 hover:text-white hover:bg-gray-800"
                        : "bg-white text-gray-500 hover:text-gray-700 hover:bg-gray-100 shadow-sm"
                  }`}
                >
                  <Icon size={18} />
                  <div className="text-left">
                    <div className="font-semibold text-sm sm:text-base">
                      {view.name}
                    </div>
                    <div className="hidden sm:block text-xs opacity-75">
                      {view.description}
                    </div>
                  </div>
                  {isActive && (
                    <ChevronRight
                      size={14}
                      className="ml-1 sm:ml-2 hidden sm:block"
                    />
                  )}
                </button>
              );
            })}
          </div>
        </div>
      </div>

      {/* Dashboard Content */}
      <div className="p-3 sm:p-8">
        {activeView === "sales" && <SalesDashboard />}
        {activeView === "cases" && <CasesDashboard />}
        {activeView === "upgrades" && <UpgradeDashboard />}
      </div>
    </div>
  );
};

export default DashboardContainer;
